export default pattern => ({
  test: pattern,
  loader: 'ignore-loader',
});

export const SCSS_PATTERN = /\.s?[ac]ss$/;
